<div
  class="bg-light rounded-2xl px-[0.5em] border-2 border-gray-light font-redHatTextSemibold flex items-center justify-center h-[2em] gap-x-[0.35em]"
>
  <ng-content select="[before]"></ng-content>
  <span class="truncate">{{ text }}</span>
  <ng-content select="[after]"></ng-content>
</div>
